import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import { useLanguage } from '../context/LanguageContext';

const Work = () => {
    const [filter, setFilter] = useState('All');
    const { t, language } = useLanguage();

    const filteredProjects = filter === 'All'
        ? projects
        : projects.filter(p => p.category === filter);

    const getVal = (en, no) => (language === 'no' ? (no || en) : en);

    return (
        <div className="page-content work-page">
            <header className="work-header">
                <h2>{t('work.title')}</h2>
                <div className="filters">
                    {['All', 'Digital Design', 'Branding', 'Print'].map(cat => (
                        <button
                            key={cat}
                            className={`filter-btn ${filter === cat ? 'active' : ''}`}
                            onClick={() => setFilter(cat)}
                        >
                            {t(`work.filters.${cat.toLowerCase().replace(' ', '_')}`)}
                        </button>
                    ))}
                </div>
            </header>

            <div className="project-grid">
                {filteredProjects.map(project => (
                    <Link to={`/project/${project.id}`} key={project.id} className="project-card">
                        <div className="image-wrapper">
                            <img src={project.heroImage} alt={project.title} />
                            <div className="overlay">
                                <span>{t('work.viewProject')}</span>
                            </div>
                        </div>
                        <div className="card-info">
                            <h3>{project.title}</h3>
                            <span className="category-tag">{getVal(project.category, project.categoryNo)}</span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Work;
